import { useDeviceType } from '@cian/ui-kit';

import type { TFirstStepBackground } from 'shared/components/Step';
import { Steps } from 'shared/components/Steps';
import { ArticleContainer } from 'shared/containers/Article';
import { StepContainer } from 'shared/containers/Step';
import type { TStep } from 'shared/types/carousel';
import type { EDealType, EOfferType, TPageType } from 'shared/types/features';
import { getStepAccent, getStepsMainTitle } from 'shared/utils/steps';

interface IStepsContainerProps {
  steps: TStep[];
  pageType: TPageType;
  dealType?: EDealType | null;
  offerType?: EOfferType | null;
  firstBackground?: TFirstStepBackground;
}

export const StepsContainer: React.FC<IStepsContainerProps> = ({
  steps,
  pageType,
  dealType,
  offerType,
  firstBackground,
}) => {
  const device = useDeviceType();
  const mainTitle = getStepsMainTitle({
    pageType,
    stepsCount: steps.length,
    dealType,
    offerType,
  });
  const resolvedFirstBackground = firstBackground ?? (pageType === 'smb' ? 'blue' : 'white');
  const isMainTitleOutside = pageType !== 'smb';
  const stepAccent = getStepAccent(pageType, dealType);

  return (
    <Steps device={device}>
      {steps.map(({ id, title, slides, banner }, index) => (
        <StepContainer
          key={id}
          step={index + 1}
          title={title}
          slides={slides.map((slide, slideIndex) => (
            <ArticleContainer key={`${slide.url}-${slideIndex}`} {...slide} categoryName={title} />
          ))}
          slidesCount={slides.length}
          isFirst={index === 0}
          banner={banner}
          mainTitle={mainTitle}
          firstBackground={resolvedFirstBackground}
          isMainTitleOutside={isMainTitleOutside}
          stepAccent={stepAccent}
        />
      ))}
    </Steps>
  );
};
